const subscriptionPlanTypes = {
  MONTHLY: 'MONTHLY',
  MONTHLY_2PCS: 'MONTHLY_2PCS',
  MONTHLY_3PCS: 'MONTHLY_3PCS',
} as const


export default subscriptionPlanTypes
